function tooltipInit(){
    $('.tooltip').click(function(e){e.preventDefault();}); //in case is an anchor
    $('.tooltip').tooltipster({        
        theme: 'tooltipster-light',
        side: 'right',
    });
}


